import { reactive } from "@vue/composition-api";
import _axios from "@/axios";
import { handleFormErrors } from "@/composables/form-error";
import { useGroup } from "@/composables/group";

export function useGroupBackground() {
  const { currentGroup } = useGroup();

  let groupBackgroundData = reactive({
    backgroundFile: null,
    backgroundFormRef: null,
    background_fileRules: [],
    dialogForBackground: false,
    deleteDialog: false,
    editedItem: null,
  });

  function uploadBackground(groupId) {
    const formData = new FormData();
    if (groupBackgroundData.backgroundFile instanceof Blob) {
      formData.append("file", groupBackgroundData.backgroundFile, "upload");
    }
    formData.append("type", "background");

    return _axios
      .post(`/group-upload/${groupId}`, formData, {
        headers: {
          "Content-Type": `multipart/form-data; boundary=${groupBackgroundData._boundary}`,
        },
      })
      .then((response) => {
        const group = response.data.data;
        currentGroup.value = group;

        groupBackgroundData.dialogForBackground = false;
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          groupBackgroundData,
          groupBackgroundData.backgroundFormRef
        );
      });
  }

  function removeBackground(groupId) {
    const formData = new FormData();
    formData.append("type", "background");

    return _axios
      .post(`/group-remove/${groupId}`, formData)
      .then((response) => {
        const group = response.data.data;

        currentGroup.value = group;
      })
      .catch(() => {});
  }

  return {
    groupBackgroundData,
    uploadBackground,
    removeBackground,
  };
}
